import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomatherantaxiservice() {



    const cardData = {

keyword: "Pune to Matheran Taxi Service",

headingDescription:
    "Rising Cab Service offers safe and comfortable Pune to Matheran Taxi Service for families, couples, tourists, and weekend travelers. We provide Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles for one-way and round-trip journeys with experienced chauffeurs. Our service includes doorstep pickup, 24/7 booking support, transparent pricing, and well-maintained cabs, ensuring a smooth and enjoyable journey from Pune to the scenic hill station of Matheran.",

topPlaces: [
    {
        title: "Charlotte Lake",
        description:
            "Charlotte Lake is one of the most picturesque attractions in Matheran and serves as a major water source for the hill station. Surrounded by dense forests and scenic walking trails, the lake offers a peaceful environment for relaxation and photography. During the monsoon season, the area becomes even more beautiful with overflowing streams and lush greenery, making it a favorite destination for nature lovers and families."
    },
    {
        title: "Panorama Point",
        description:
            "Panorama Point is among the highest and most famous viewpoints in Matheran, offering breathtaking 360-degree views of the Sahyadri hills and surrounding valleys. Visitors especially enjoy the spectacular sunrise and the mist-covered landscapes during the monsoon and winter seasons. It is an ideal location for sightseeing and photography."
    },
    {
        title: "Echo Point",
        description:
            "Echo Point is a popular tourist attraction where visitors can experience the natural echo effect while enjoying magnificent views of the valleys and green hills. The cool climate and scenic surroundings make it one of the most visited spots in Matheran for families and children."
    },
    {
        title: "Louisa Point",
        description:
            "Louisa Point offers stunning panoramic views of deep valleys, waterfalls, and the historic Prabal Fort. The viewpoint is particularly attractive during the rainy season when the entire landscape is covered with lush greenery and flowing streams. It is one of the best photography spots in Matheran."
    },
    {
        title: "Alexander Point",
        description:
            "Alexander Point is known for its peaceful atmosphere and spectacular views of the surrounding mountains and forests. Visitors can enjoy the fresh air, scenic beauty, and distant views of the Ulhas River valley, making it a perfect spot for relaxation."
    },
    {
        title: "One Tree Hill Point",
        description:
            "One Tree Hill Point is a unique attraction named after a solitary tree standing on the hilltop. The viewpoint offers beautiful trekking trails and panoramic views of the surrounding valleys and mountain ranges, attracting adventure enthusiasts and nature lovers."
    },
    {
        title: "Matheran Toy Train",
        description:
            "The Matheran Toy Train is a UNESCO-recognized heritage railway that offers a memorable journey through forests, tunnels, and scenic mountain landscapes. The slow-paced ride provides visitors with a unique and charming way to experience the beauty of Matheran."
    },
    {
        title: "Porcupine Point",
        description:
            "Porcupine Point, also known as Sunset Point, is one of the best places in Matheran to witness spectacular sunsets over the Sahyadri hills. The viewpoint offers breathtaking scenery and is a popular destination for evening sightseeing and photography."
    },
    {
        title: "Prabal Fort View",
        description:
            "The viewpoints around Matheran provide excellent views of the historic Prabal Fort, an ancient hill fort associated with Maratha history. The combination of historical significance and natural beauty makes this area highly attractive to visitors."
    },
    {
        title: "Paymaster Park",
        description:
            "Paymaster Park is a peaceful garden in Matheran featuring beautiful landscapes, colorful flowers, and open green spaces. It is an ideal place for families and children to relax while enjoying the pleasant climate and natural surroundings of the hill station."
    }
],



services: [
{
name: "Pune to Matheran Cab",
description: "Rising Cab Service offers Pune to Matheran Cab with safe, comfortable, and affordable travel for families, couples, tourists, and corporate travelers. Book AC Sedan, SUV, Ertiga, Innova Crysta, and Tempo Traveller vehicles for one way, round trip, and sightseeing journeys with experienced drivers and doorstep pickup."
},
{
name: "Pune to Matheran Taxi",
description: "Book Pune to Matheran Taxi with Rising Cab Service for reliable and hassle-free transportation. We provide clean vehicles, professional chauffeurs, transparent pricing, and 24x7 booking for weekend trips, holidays, and business travel."
},
{
name: "Cab from Pune to Matheran",
description: "Our Cab from Pune to Matheran service provides comfortable long-distance travel with flexible pickup and drop locations. Enjoy a smooth journey in well-maintained vehicles suitable for solo, family, and group travel."
},
{
name: "Taxi from Pune to Matheran",
description: "Rising Cab Service provides Taxi from Pune to Matheran with safe highway travel, affordable fares, and experienced drivers for one way and round trip requirements."
},
{
name: "Pune to Matheran Cab Service",
description: "Our Pune to Matheran Cab Service is designed for convenient and budget-friendly travel with multiple cab options including Sedan, SUV, Ertiga, and Innova Crysta for comfortable hill station journeys."
},
{
name: "Pune to Matheran Taxi Fare",
description: "Get affordable Pune to Matheran Taxi Fare with transparent pricing and no hidden charges. Rising Cab Service offers economical one way, round trip, and tour packages."
},
{
name: "Pune to Matheran One Way Cab",
description: "Book Pune to Matheran One Way Cab for economical travel with convenient pickup and drop service, professional drivers, and comfortable AC vehicles."
},
{
name: "Pune to Matheran Round Trip Taxi",
description: "Our Pune to Matheran Round Trip Taxi service is ideal for same-day tours and weekend getaways with waiting options and return journey convenience."
},
{
name: "Pune to Matheran Cab Booking",
description: "Rising Cab Service offers Pune to Matheran Cab Booking with instant confirmation, multiple vehicle choices, and 24x7 customer support for stress-free travel."
},
{
name: "Cheap Pune to Matheran Cab",
description: "Choose Cheap Pune to Matheran Cab for budget-friendly travel without compromising comfort and safety. Perfect for families, students, and group travelers."
},
{
name: "Best Pune to Matheran Cab",
description: "Rising Cab Service provides the Best Pune to Matheran Cab with premium vehicles, trained chauffeurs, punctual service, and comfortable travel experiences."
},
{
name: "One Way Pune to Matheran Cab",
description: "Our One Way Pune to Matheran Cab service offers affordable travel with flexible scheduling, comfortable AC cars, and reliable transportation."
},
{
name: "Round Trip Pune to Matheran Taxi",
description: "Book Round Trip Pune to Matheran Taxi for sightseeing, holidays, and family trips with convenient return travel and affordable rates."
},
{
name: "Pune to Matheran Cab Package",
description: "Rising Cab Service offers Pune to Matheran Cab Package including comfortable transportation, sightseeing options, and flexible travel plans for families and groups."
},
{
name: "Matheran Tour Package from Pune",
description: "Our Matheran Tour Package from Pune provides a complete travel solution with comfortable cab service, sightseeing, and customized itineraries for memorable vacations."
},
{
name: "Pune to Matheran Taxi Package",
description: "Book Pune to Matheran Taxi Package with affordable pricing, experienced drivers, and comfortable vehicles for family holidays and weekend getaways."
},
{
name: "Pune Matheran Family Tour Cab Package",
description: "Rising Cab Service provides Pune Matheran Family Tour Cab Package with spacious vehicles, safe travel, and customized tour plans for enjoyable family vacations."
},
{
name: "Pune to Matheran Holiday Cab Package",
description: "Our Pune to Matheran Holiday Cab Package offers stress-free travel with flexible itineraries, comfortable vehicles, and professional drivers for relaxing holidays."
},
{
name: "Pune to Matheran Sightseeing Cab Package",
description: "Book Pune to Matheran Sightseeing Cab Package for convenient travel to popular attractions with experienced drivers and comfortable AC vehicles."
},
{
name: "Luxury Matheran Cab Package Pune",
description: "Rising Cab Service offers Luxury Matheran Cab Package Pune with premium Sedan, SUV, and Innova Crysta vehicles for elegant and comfortable travel experiences."
},
{
name: "Pune to Matheran Tempo Traveller Package",
description: "Our Pune to Matheran Tempo Traveller Package is perfect for large families and group tours with spacious seating, AC comfort, and affordable travel rates."
}
],

tableData: [
["Pune to Matheran Cab","Pune to Matheran Taxi"],
["Cab from Pune to Matheran","Taxi from Pune to Matheran"],
["Pune to Matheran Cab Service","Pune to Matheran Taxi Fare"],
["Pune to Matheran One Way Cab","Pune to Matheran Round Trip Taxi"],
["Pune to Matheran Cab Booking","Cheap Pune to Matheran Cab"],
["Best Pune to Matheran Cab","One Way Pune to Matheran Cab"],
["Round Trip Pune to Matheran Taxi","Pune to Matheran Cab Package"],
["Matheran Tour Package from Pune","Pune to Matheran Taxi Package"],
["Pune Matheran Family Tour Cab Package","Pune to Matheran Holiday Cab Package"],
["Pune to Matheran Sightseeing Cab Package","Luxury Matheran Cab Package Pune"],
["Pune to Matheran Tempo Traveller Package","Hill Station Taxi Pune Matheran"]
],



whychoose: [
    {
        WhyChooseheading: "Reliable Pune to Matheran Taxi Service",
        WhyChoosedescription: "Rising Cab Service provides comfortable Pune to Matheran taxi transportation for families, couples, tourists, weekend travelers, and nature lovers."
    },
    {
        WhyChooseheading: "Perfect for Hill Station Getaways",
        WhyChoosedescription: "Matheran is one of Maharashtra's most beautiful eco-friendly hill stations, making it an ideal destination for vacations, relaxation, and sightseeing."
    },
    {
        WhyChooseheading: "Convenient Travel for Families and Couples",
        WhyChoosedescription: "Whether planning a family holiday, romantic getaway, group outing, or weekend escape, we offer travel solutions suitable for every traveler."
    },
    {
        WhyChooseheading: "Wide Choice of Comfortable Vehicles",
        WhyChoosedescription: "Customers can choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles based on group size and travel preferences."
    },
    {
        WhyChooseheading: "Flexible One-Way and Round Trip Options",
        WhyChoosedescription: "We offer one-way taxi services, same-day return plans, overnight stays, weekend packages, and customized travel itineraries."
    },
    {
        WhyChooseheading: "Pickup Service Available Across Pune",
        WhyChoosedescription: "Doorstep pickup facilities are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby locations."
    },
    {
        WhyChooseheading: "Enjoy Scenic Routes and Nature Views",
        WhyChoosedescription: "The journey to Matheran offers beautiful mountain landscapes, greenery, and peaceful surroundings that enhance the travel experience."
    },
    {
        WhyChooseheading: "Professional Drivers for Safe Travel",
        WhyChoosedescription: "Our experienced drivers ensure a smooth, safe, and comfortable journey, allowing travelers to enjoy their trip without any travel concerns."
    }
]
};

const faqData = [
    {
        question: "Why is Matheran a popular tourist destination from Pune?",
        answer: "Matheran is famous for its scenic viewpoints, toy train, pleasant weather, lush greenery, and vehicle-free environment."
    },
    {
        question: "Can I book a one-way taxi from Pune to Matheran?",
        answer: "Yes, one-way taxi services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which tourist attractions can be visited in Matheran?",
        answer: "Popular attractions include Panorama Point, Echo Point, Charlotte Lake, Louisa Point, Monkey Point, and Sunset Point."
    },
    {
        question: "Which vehicle is best for a family trip to Matheran?",
        answer: "Ertiga and Innova Crysta are commonly preferred due to their spacious seating and comfortable ride quality."
    },
    {
        question: "Do you provide Tempo Travellers for group tours?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate outings, and tourist groups."
    },
    {
        question: "Can same-day return trips be arranged from Pune?",
        answer: "Yes, same-day return taxi packages can be organized depending on the travel schedule and sightseeing plans."
    },
    {
        question: "Is Matheran suitable for couples and honeymoon travelers?",
        answer: "Yes, Matheran is a popular destination for couples due to its peaceful atmosphere, scenic beauty, and romantic viewpoints."
    },
    {
        question: "Can customers customize their sightseeing itinerary?",
        answer: "Yes, travel plans can be customized to include preferred attractions, viewpoints, and nearby destinations."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I reserve a Pune to Matheran Taxi Service?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rohit Bhosale",
        feedback:
            "Our weekend escape to Matheran was wonderfully organized. The vehicle was comfortable, the journey was relaxing, and we reached the destination without any hassle.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Shweta Kulkarni",
        feedback:
            "The scenic drive and professional service made our Matheran vacation even more enjoyable. Everything was handled smoothly, and the travel experience was excellent.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Matheran Taxi Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-matheran-cab.jpg",
"description": "Book Pune to Matheran Taxi Service with Rising Cab Service for safe, comfortable, and scenic hill station travel. Enjoy reliable one-way and round-trip cab service with AC sedans, SUVs, and Innova cars at affordable prices.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-matheran-cab"
}
};







    return (
        <div>


<Helmet>
  <title>Pune to Matheran Taxi Service | Hill Station Cab | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Matheran Taxi Service for safe and scenic hill station travel. Get affordable one-way and round-trip cab service with AC sedans, SUVs, and Innova cars."
/>

<meta
 name="keywords"
 content="pune to matheran cab, pune to matheran taxi, cab from pune to matheran, taxi from pune to matheran, pune to matheran cab service, pune to matheran taxi fare, pune to matheran one way cab, pune to matheran round trip taxi, pune to matheran cab booking, cheap pune to matheran cab, best pune to matheran taxi, sedan pune to matheran cab, suv pune to matheran taxi, innova pune to matheran cab, hill station taxi pune matheran, Pune to Matheran Cab, Pune to Matheran Cab Service, Pune to Matheran Taxi Service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/54.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomatherantaxiservice;